import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { OracleAccesses } from "./accesses.ts";
import { OracleComponents } from "./components.ts";

const OracleFilters = {
  compartmentId: { keys: ["id", "name"] },
  domainId: { keys: ["id", "name"] },
  groupId: { keys: ["id", "name"] },
} as const satisfies AnyFilterSchema;

export type OracleFilters = typeof OracleFilters;

export const OracleRegistration = Registration({
  accesses: OracleAccesses,
  category: "resource",
  components: OracleComponents,
  docs: {
    install: "oracle-cloud",
    request: "oracle-cloud/requesting-access",
  },
  filters: OracleFilters,
  identifier: "OCID",
  itemKind: "domain",
  label: "Oracle Cloud",
  logoUrl:
    "https://upload.wikimedia.org/wikipedia/commons/e/e1/Oracle_Corporation_logo.svg",
  maturity: "preview",
  requestType: "requestable",
  // TODO: Should map iam_write, but was copied from existing code that omitted this mapping
  useMapping: [],
});

registerIntegration("oci", OracleRegistration);
